import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { PagedResponse, ReferansItem, ReferansUpdate } from '../types'

const BASE = '/management/referans'

/** Aktif referanslar (opsiyonel TİP + ad araması; size=200). */
export async function getReferans(type?: string, q?: string): Promise<PagedResponse<ReferansItem>> {
  const { data } = await apiClient.get<PagedResponse<ReferansItem>>(BASE, {
    params: {
      page: 0,
      size: 200,
      type: type && type.trim() ? type.trim() : undefined,
      q: q && q.trim() ? q.trim() : undefined,
    },
  })
  return data
}

/** Aktif referansların ayrık TİP listesi (filtre dropdown'u). */
export async function getReferansTypes(): Promise<string[]> {
  const { data } = await apiClient.get<string[]>(`${BASE}/types`)
  return data
}

/** Referans ad (TR/EN) güncelleme (018). Yalnız ad değişir; modDate optimistic lock. */
export async function updateReferans(id: number, body: ReferansUpdate): Promise<ReferansItem> {
  const { data } = await apiClient.put<ReferansItem>(`${BASE}/${id}`, body)
  return data
}

/**
 * Referans listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportReferans(type?: string, q?: string): Promise<void> {
  await downloadXlsx(`${BASE}/export`, { type, q }, 'referans.xlsx')
}
